import { Component, EventEmitter, OnInit, Output, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DocumentoModel } from 'src/app/core/models/documento.model';
import { VehiculoModel } from 'src/app/core/models/vehiculo.model';
import { DistintivoAmbientalService } from 'src/app/core/services/maestras/distintivo-ambiental.service';
import { SectorService } from 'src/app/core/services/maestras/sector.service';
import { TipoCombustibleService } from 'src/app/core/services/maestras/tipo-combustible.service';
import { TipoPlazaService } from 'src/app/core/services/maestras/tipo-plaza.service';
import { TipoVehiculoService } from 'src/app/core/services/maestras/tipo-vehiculo.service';
import { UsoVehiculoService } from 'src/app/core/services/maestras/uso-vehiculo.service';
import { UserModel } from 'src/app/core/models/user.model';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';
import { Input } from '@angular/core';


@Component({
  selector: 'dum-registro-vehiculo',
  templateUrl: './registro-vehiculo.component.html',
  styleUrls: ['./registro-vehiculo.component.scss']
})
export class RegistroVehiculoComponent extends BaseComponent implements OnInit {

  @ViewChildren('registroVehiculoForm') registroVehiculoForm: NgForm;
  @Input() vehiculo: VehiculoModel = new VehiculoModel();
  @Output() eventSiguienteVehiculo: EventEmitter<VehiculoModel> = new EventEmitter<VehiculoModel>();
  @Output() eventAnteriorToUsuario: EventEmitter<boolean> = new EventEmitter<boolean>();
  nuevoPropietario: UserModel;
  usuarios: UserModel;
  documentos: DocumentoModel[] = [];
  cambiosForm: [] = [];
  anterior: boolean = true;
  mensajeErrorMatricula: boolean = false;
  submitted: boolean = false;
  isAllData: boolean = false;

  constructor(
    protected tipoVehiculoService: TipoVehiculoService,
    protected tipoCombustibleService: TipoCombustibleService,
    protected usosVehiculosServices: UsoVehiculoService,
    protected sectoresService: SectorService,
    protected distintivosAmbientalesServices: DistintivoAmbientalService,
    protected clasificacionVehiculoService: TipoPlazaService,
  ) {
    super(
      sectoresService,
      tipoVehiculoService,
      tipoCombustibleService,
      usosVehiculosServices,
      distintivosAmbientalesServices,
      clasificacionVehiculoService
    );
  }

  ngOnInit(): void {
    this.validAllData();
    this.initData();
  }

  volver() {
    this.eventAnteriorToUsuario.emit(this.anterior);
  }

  validadorMatricula() {
    const expreg = /[0-9][0-9][0-9][0-9][a-z A-Z+][a-z A-Z+][a-z A-Z+]$/;
    if (expreg.test(this.vehiculo.matricula)) {
      this.mensajeErrorMatricula = false;
      return true;
    }
    else {
      this.mensajeErrorMatricula = true;
      return false;
    }
  }

  siguienteVehiculo() {
    this.vehiculo.matricula.toUpperCase();
    if (this.validadorMatricula()) {
      this.submitted = true;
      this.eventSiguienteVehiculo.emit(this.vehiculo);
    }
  }

  validAllData() {
    if (this.vehiculo.distintivoAmbiental.id
        && this.vehiculo.clasificacionVehiculo.id
          && this.vehiculo.tipoCombustible.id
            && this.vehiculo.usoVehiculo.id) {
              if (this.vehiculo.usoVehiculo.id === 1)  {
                      this.isAllData = true;
                    } else if ( this.vehiculo.usoVehiculo.id === 2
                      && this.vehiculo.sector.id)  {
                      this.isAllData = true;
                    } else if ( this.vehiculo.usoVehiculo.id === 2
                      && !this.vehiculo.sector.id) {
                        this.isAllData = false;
                      }
    }
  }

  initData(){
   // Obtención tipos clasificacion de los vehículos
    this.getClasificacionVehiculos();
    // Obtención de los distintivos ambientales.
    this.getDistintivosAmbientales();
    // Obtención de todos los sectores.
    this.getSectores();
    // Obtención de los usos de vehiculos existentes.
    this.getUsosVehiculos();
    // Obtención de los tipos de combustibles.
    this.getTipoCombustible();
    // Obtención de los tipos de vehículos.
    this.getTipoVehiculo();
  }

}
